import React from 'react'
import { useTranslation } from 'react-i18next'

import { UpdateRepInput, UpdateRepLabel, UpdateRepWrapper } from './style'

export const UpdateRepetition = () => {
  const { t } = useTranslation()
  return (
    <UpdateRepWrapper>
      <UpdateRepInput type="checkbox" />
      <UpdateRepLabel>
        {t('Update repetitions after this appointment')}
      </UpdateRepLabel>
    </UpdateRepWrapper>
  )
}
